module.exports = __webpack_public_path__ + "img/hk-skyline.bcb218db.jpg";